<template>
	<div v-if="salesOwner?.user_id && salesOwner.profile_id" class="salesOwnerCard">
		<div class="title">{{ translations['request-title'] }}</div>
		<p>{{ translations['reach-out'] }}</p>
		<br>
		<p class="is-size-3">{{ salesOwner.userprofile.full_name }}</p>
		<div>
			<a :href="phoneLink" target="_blank">
				<i class="fa-light fa-mobile-notch"> </i>
				{{ salesOwner.userprofile.phone }}
			</a>
		</div>
		<div>
			<a :href="emailLink" target="_blank">
				<i class="fa-solid fa-envelope"></i>
				{{ salesOwner.email }}
			</a>
		</div>
	</div>
</template>
<script>
	import {ApiMonizze} from "../../api-monizze";

	export default {
		data: function ()
		{
			return {
				salesOwner: {
					user_id: '',
					profile_id: '',
					email: '',
					userprofile: {
						firstname: '',
						lastname: '',
						phone: '',
						full_name: ''
					}
				}
			}
		},
		props: {
			url: {
				type: String,
				required: true,
			},
			translations: {
				type: Object,
				required: true
			}
		},
		mounted() {
			this.loadSalesOwner()
		},
		methods: {
			loadSalesOwner: async function()
			{
				await new ApiMonizze()
					.getDataFromApi(
							this.$props.url,
							(response) => {
								this.salesOwner = response.salesOwner
							}
					);
			}
		},
		computed: {
			emailLink: function()
			{
				return 'mailto:' + this.salesOwner.email
			},
			phoneLink: function()
			{
				return 'tel:' + this.salesOwner.userprofile.phone
			}
		}
	}
</script>

<style scoped>
	.salesOwnerCard {
		border-radius: 8px;
		border: 1px solid #1F2524;
		background: #37403F; color:white;
		padding: 40px 24px 40px 24px;
	}

	.title, a {
		color: white;
	}

	a > i {
		text-decoration: none;
	}
</style>